// components/common/Header.tsx
import { Navbar, Form, Row, Col, Button } from "react-bootstrap";
import { IoSearchOutline } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import { Link } from "react-router-dom";

interface HeaderProps {
  title: string;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  actionButton?: {
    text: string;
    link: string;
    variant?: string;
    style?: React.CSSProperties;
  };
}

export const PageHeader = ({
  title,
  searchQuery,
  onSearchChange,
  actionButton,
}: HeaderProps) => {
  return (
    <Navbar expand="lg" className="py-3 p-4 bg-transparent">
      <Navbar.Brand className="fs-4">{title}</Navbar.Brand>

      <Navbar.Toggle aria-controls="header-navbar" className="navbar-toggler">
        <RxHamburgerMenu className="text-black fs-4" />
      </Navbar.Toggle>

      <Navbar.Collapse id="header-navbar">
        <Row className="ms-auto flex-wrap align-items-center">
          <Col className="mx-auto m-0 p-0 position-relative">
            <span className="position-absolute ps-2 pt-2 py-auto">
              <IoSearchOutline />
            </span>
            <Form.Control
              type="search"
              className="py-2 border border-1 rounded-5"
              style={{ paddingLeft: "1.8rem" }}
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </Col>
          {actionButton && (
            <Col>
              <Link to={actionButton.link}>
                <Button
                  className="py-2 mx-1 rounded-5"
                  variant={actionButton.variant || "light"}
                  style={actionButton.style}
                >
                  {actionButton.text}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </Navbar.Collapse>
    </Navbar>
  );
};
